import { Dispatch, SetStateAction } from 'react';

import { CreateSpeaker, Speaker } from '@/types/speakers.types';
import GlobalContainer from '@ui/container/global-container';
import Text from '@ui/text/text/text';

type TEditLocationProps = {
  workingSpeaker: Speaker | CreateSpeaker;
  setWorkingSpeaker: Dispatch<SetStateAction<Speaker | CreateSpeaker>>;
};

const EditLocation = ({ workingSpeaker, setWorkingSpeaker }: TEditLocationProps) => {
  return (
    <label htmlFor="location" className="flex-1 flex-column gap-4 width-100-percent">
      <Text design="GlobalIcoText3" className="P2 margin-l-16">
        Location
      </Text>
      <GlobalContainer<'input'>
        id="location"
        TagName="input"
        type="text"
        value={workingSpeaker?.location || ''}
        onChange={(e) => setWorkingSpeaker((prev) => ({ ...prev, location: e.target.value }))}
        css="background-color: transparent; width: 100%; padding: 10px 16px; outline: none; border: 1px solid var(--global-ico-text-3); border-radius: 100px;"
        className="P2"
        mode="GlobalIcoText1"
        placeholder="Add location"
      />
    </label>
  );
};

export default EditLocation;
